export default __webpack_public_path__ + "static/media/word.9df3a082.jpg";